module.exports = window["popupMaker"]["components"];